import { updateFetchedData } from './update-fetched-data';
/**
 * Updates a [[FetchedDataRecord]] by merging a newer [[FetchedDataRecord]], similar to Object.assign.
 *
 * Creates a superset of [[FetchedData]], while retaining the longest expiry times to prevent premature cache expiry.
 *
 * @returns Returns the updated [[FetchedDataRecord]].
 */
export function updateFetchedDataRecord(target, source) {
    for (const [key, sourceValue] of Object.entries(source)) {
        const targetValue = target[key];
        if (targetValue) {
            updateFetchedData(targetValue, sourceValue);
        }
        else {
            target[key] = sourceValue;
        }
    }
    return target;
}
//# sourceMappingURL=update-fetched-data-record.js.map